import { buildStorageKey } from '@lib/listStateNormalizer'

export interface ListStateStorageScope {
  orgId?: string
  routeId: string
  scope?: string
  tableId?: string
}

export interface ListStateService {
  buildKey: (scope: ListStateStorageScope) => string
  get: <T>(key: string) => T | null
  set: <T>(key: string, value: T) => void
  remove: (key: string) => void
}

export function createListStateService(): ListStateService {
  return {
    buildKey: ({ orgId, routeId, scope, tableId }) =>
      buildStorageKey(orgId, routeId, scope, tableId),
    get: <T>(key: string) => {
      if (typeof window === 'undefined') {
        return null
      }

      try {
        const raw = window.sessionStorage.getItem(key)
        if (!raw) {
          return null
        }

        return JSON.parse(raw) as T
      } catch {
        return null
      }
    },
    set: <T>(key: string, value: T) => {
      if (typeof window === 'undefined') {
        return
      }

      try {
        window.sessionStorage.setItem(key, JSON.stringify(value))
      } catch {
        // ignore write failures (private mode / quota / disabled storage)
      }
    },
    remove: (key: string) => {
      if (typeof window === 'undefined') {
        return
      }

      try {
        window.sessionStorage.removeItem(key)
      } catch {
        // ignore remove failures
      }
    },
  }
}
